import { DEFAULT_INITIALS } from "../constants";

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export function normalizeInitials(raw: string): string {
  const letters = raw
    .toUpperCase()
    .replace(/[^A-Z]/g, "")
    .slice(0, 3);
  return letters.padEnd(3, "A");
}

export function isValidInitials(value: string): boolean {
  return /^[A-Z]{3}$/.test(value);
}

export function stepLetter(current: string, direction: 1 | -1): string {
  const index = LETTERS.indexOf(current);
  const from = index < 0 ? 0 : index;
  const next = (from + direction + LETTERS.length) % LETTERS.length;
  return LETTERS[next] ?? "A";
}

export function defaultInitialsArray(): [string, string, string] {
  return [...DEFAULT_INITIALS] as [string, string, string];
}

export function replaceInitialAt(
  initials: readonly string[],
  index: number,
  letter: string,
): [string, string, string] {
  const next = [...initials] as [string, string, string];
  const normalized = letter.toUpperCase().replace(/[^A-Z]/g, "");
  if (normalized && index >= 0 && index < 3) {
    next[index] = normalized[0] ?? "A";
  }
  return next;
}
